/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"


// /////////////////////////////////////////////
// Variables
// /////////////////////////////////////////////
/*
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "John Doe", // From Auth
  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status      : "online",
  userRole    : "admin"
}*/
 

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}

// Set default values for active-AppActiveUser
// More data can be added by auth provider or other plugins/packages


const getUserInfo = () => {
  let userInfo = {
    photoURL : require("@/assets/images/portrait/small/eu2.jpg"), // From Auth
  }
  // Update property in AppActiveUser
   // If property is defined in localStorage => Use that
  /*Object.keys(AppActiveUserDefaults).forEach((key) => {
   
    AppActiveUserInfo[key] = AppActiveUserInfoLocalStorage[key] ?  AppActiveUserInfoLocalStorage[key] : AppActiveUserDefaults[key]
  })*/

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
  })
  return userInfo
}
// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    user                    : null,
    avatar                  :null,
    products                :[],
    totalProducts                :[],
    currentProducts          :[],
    itemsPerPageProducts    :15,
    users                   :[],
    usersFiltered           :[],
    usersOnline             :[],
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,
    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
}

export default state
